import { useState, useEffect } from 'react';
import { Active } from '../../imports/Active';

const frames = [
  { property1: '1' as const, state: 'running' as const },
  { property1: '2' as const, state: 'running' as const },
  { property1: 'Variant3' as const, state: 'stopping' as const },
  { property1: 'Variant4' as const, state: 'stopping' as const },
];

export function AnimatedGiraffe({
  className,
  color = '#2D178B',
}: {
  className?: string;
  color?: string;
}) {
  const [frame, setFrame] = useState(0);
  const [animState, setAnimState] = useState<'running' | 'stopping' | 'stopped'>('running');

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (animState === 'running') {
      timeoutId = setTimeout(() => {
        setFrame((prev) => (prev + 1) % 4);
      }, 135);
    } else if (animState === 'stopping') {
      timeoutId = setTimeout(() => {
        if (frame !== 3) {
          setFrame((prev) => prev + 1);
        } else {
          setAnimState('stopped');
        }
      }, 135);
    }

    return () => clearTimeout(timeoutId);
  }, [frame, animState]);

  const handleClick = () => {
    if (animState === 'running') {
      setAnimState('stopping');
    } else if (animState === 'stopped' || animState === 'stopping') {
      setFrame(0);
      setAnimState('running');
    }
  };

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      className={`relative cursor-pointer appearance-none bg-transparent border-none p-0 m-0 outline-none hover:scale-[1.02] active:scale-[0.98] transition-transform ${className || 'w-full h-full'}`}
      style={{ '--fill-0': color } as React.CSSProperties}
      aria-label={animState === 'running' ? 'Stop animation' : 'Start animation'}
    >
      {frames.map((f, i) => (
        <div
          key={i}
          className="absolute inset-0 [&>*]:!block [&>*]:!relative [&>*]:!w-full [&>*]:!h-full [&>*]:!border-0 [&>*]:!p-0 [&>*]:!m-0 [&>*]:!bg-transparent [&_svg]:!top-0 [&_svg]:!left-0 pointer-events-none"
          style={{ visibility: i === frame ? 'visible' : 'hidden' }}
        >
          <Active property1={f.property1} state={f.state} />
        </div>
      ))}
    </div>
  );
}
